// extracted by mini-css-extract-plugin
module.exports = {"content":"_SuccessPage_content_Hz-4U","header":"_SuccessPage_header_2pxsx"};